import React from 'react';
import { Container } from '../Container';
import { Section } from '../Section';
import { Reveal } from '../Reveal';
import { pricingTiers } from '../../data/pricing';
import { comparisonRows } from '../../data/pricingDetails';
export function ComparisonTable() {
  return <Section bordered labelledBy="comparison-title" data-id="element-690" data-mp="3n8kyywoe1nc2">
      <Container data-id="element-691" data-mp="3n9w0epud2j00">
        <Reveal data-id="element-692" data-mp="3n9cts5a5vh1a">
          <h2 id="comparison-title" className="max-w-[16ch] text-[40px] leading-[1.05] tracking-[-0.03em] text-ink lg:text-[56px]" data-id="element-693" data-mp="3naxfr6ietrnj">
            The three plans, side by side.
          </h2>
          <p className="mt-6 max-w-[52ch] text-body text-muted" data-id="element-694" data-mp="39hpm79arqm37">
            Most rows are identical, which is the point. The differences are page count, CMS depth
            and what gets migrated.
          </p>
        </Reveal>

        <Reveal delay={0.06} className="mt-14 lg:mt-16" data-id="element-695" data-mp="opnsirzlt61o">
          <div className="overflow-x-auto" data-id="element-696" data-mp="js4ftwik11bu">
            <table className="w-full min-w-[720px] border-collapse text-left" data-id="element-697" data-mp="jr2saskcqmd8">
              <caption className="sr-only" data-id="element-698" data-mp="1b9dckxl1cw1z">
                Comparison of the Starter, Standard and Custom plans
              </caption>
              <thead data-id="element-699" data-mp="1g5tz5ncl72cy">
                <tr className="border-y border-hairline" data-id="element-700" data-mp="1l6rpwobnx4q2">
                  <th scope="col" className="w-[28%] py-5 pr-6 text-small font-medium text-muted" data-id="element-701" data-mp="1l7awj8vv46os">
                    Feature
                  </th>
                  {pricingTiers.map(tier => <th key={tier.name} scope="col" className="py-5 pr-6 text-small font-semibold text-ink" data-id="element-702" data-mp="sjngm75je48h">
                      {tier.name}
                      {tier.highlighted && <span className="ml-2 align-middle text-[12px] font-medium text-accent" data-id="element-703" data-mp="1781st8ouf51p">
                          Most Popular
                        </span>}
                    </th>)}
                </tr>
              </thead>
              <tbody data-id="element-704" data-mp="6pq6eacscox0">
                {comparisonRows.map(row => <tr key={row.label} className="border-b border-hairline" data-id="element-705" data-mp="6nwzqv26a4p0">
                    <th scope="row" className="py-5 pr-6 align-top text-small font-normal text-muted" data-id="element-706" data-mp="1qdhzl69n9sb">
                      {row.label}
                    </th>
                    {row.values.map((value, index) => <td key={`${row.label}-${pricingTiers[index].name}`} className="py-5 pr-6 align-top text-small text-ink" data-id="element-707" data-mp="3jxb2k4oqilpf" data-mpi={index}>
                        {value}
                      </td>)}
                  </tr>)}
              </tbody>
            </table>
          </div>
        </Reveal>
      </Container>
    </Section>;
}